export default __webpack_public_path__ + "static/BW-link-cover-ENG-b288711faa2af8eeb47e4d97353030ce.jpg";